/**
 * View Type Constants - CSS classes and layout variants for different view types
 * Used by AppViewModel to determine which CSS styles apply to each page
 * 
 * @typedef {Object} ViewTypes
 * @property {string} DEFAULT - Default view type for general site content
 * @property {string} LEGAL - Legal pages (privacy policy, terms of service)
 * @property {string} PRODUCT_DETAIL - Product detail/showcase pages
 * @property {string} PRODUCT_GUIDE_BOOK - Product guidebook/content pages
 */

export const VIEW_TYPES = {
    DEFAULT: 'default',
    LEGAL: 'legal',
    PRODUCT_DETAIL: 'productDetail',
    PRODUCT_GUIDE_BOOK: 'productGuideBook'
};
